const ROUTE = {
  Login: "/",
  Register: "/register",
  Home: "/home",
  Reseller: "/reseller",
  Coupon: "/coupon",
  ForgotPassword: "/forgotPassword",
  ResetPassword: "/resetPassword",
  VerifyEmail: "/email/verifyLink/:email/:token",
  SmsPage: "/sms/:action/:email/:otp",
  DeleteAccount: "/email/removeAccount/:email/:token",
  DeleteGateway: "/email/removeGateway/:email/:token",
  DeleteBeacon: "/email/removeBeacon/:email/:token",
  VerifyForgotPassword: "/email/verifyForgotPassword/:email/:token",
  VerifyChangePassword: "/email/verifyChangePassword/:email/:token",
  Verify2FA: "/email/verify2FA/:email/:token",
  VerifyFamilyLink: "/email/VerifyFamilyLink/:email/:token",
  VerifyTrustedContactLink: "/email/RemoveLockBeacon/:email/:token",
  ViewReseller: "/viewReseller",
  Warranty: "/warranty",
  DemoPage: "/Demo",
  DemoGraph: "/Demo/Graph",
  Configuration: "/Configurations",
  RssiConfig: "/Configurations/rssi",
  EmailConfig: "/Configurations/email",
  CustomMessage: "/customMessage",
  UserReports: "/userReports",
  SmsNotifications: "/SmsNotifcations",
  Sponsors: "/Sponsors",
  UpdateSponsor: "/UpdateSponsor",
  TermOfCondition: "/TermOfServices",
  SponsorAnalytics: "/Analytics/:sponsorId",
  Analytics: "/Analytics",
  SponsorList: "/sponsorList",
  DownloadSponsorReport: "/DownloadReport",
  DownloadSummaryReport: "/DownloadSummaryReport",
  DownloadSponsorsAccountsListsReport: "/DownloadSponsorsAccountsListReport",
  AuditLogs: "/auditlogs",
};

export default ROUTE;
